import React, { useState} from 'react';

const CountrySelect = ({ source, setCountry }) => {
    const [value, setValue] = useState(0);

    const handleChange = (event) => {
        setValue(event.target.value);
        setCountry(event.target.value);
    };

    if (undefined === source.countries) {
        return null;
    }

    return (
        <p>
            <label>Country</label>
            <select id='countrySelect' onChange={event => handleChange(event)} value={value} className="cr_filters_dd_ctr" name="ctr" size="3">
                <option value={0} key={0}>all countries</option>
                {source.countries.map(country => (
                    <option key={country.id} value={country.id}>{country.name}</option>
                ))}
            </select>
        </p>
    );
};

export default CountrySelect;
